import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/stable';
// import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import { ENV } from './utils/configuration';

// Journalisation des erreurs (Sentry).
//
// L'adresse du projet (le « DSN ») est écrite ici, en dur, et c'est voulu. Un DSN est une
// clé d'ÉCRITURE seule : il permet d'envoyer une erreur, il ne donne accès à rien. Et il
// finit de toute façon en clair dans le paquet livré au navigateur — le sortir dans une
// variable ne cacherait rien.
//
// Ce qu'une variable apporterait, c'est une adresse différente par environnement. On n'en
// veut pas : un seul projet Sentry reçoit staging ET production, séparés par l'étiquette
// `environment` ci-dessous. En échange, une variable coûte cher : elle est figée à la
// CONSTRUCTION du paquet, donc si la personne qui construit la production oublie de la
// poser, Sentry est muet et rien ne le signale. Une valeur en dur ne s'oublie pas.
//
// ⚠️ À vérifier de temps en temps qu'elle est encore la bonne. L'adresse écrite ici en
// mars 2021 était celle des ANCIENS propriétaires du code : Soumigo leur a envoyé ses
// erreurs pendant quatre ans sans que personne s'en aperçoive.
const SENTRY_DSN = 'https://9e1d25969aeeca79a0f7089a1782a1c6@o4505720216420352.ingest.us.sentry.io/4511938939715584';

// Rien n'est envoyé depuis un poste de travail : `ENV` vaut 'localhost' tant que
// REACT_APP_ENV n'est pas posé (utils/configuration.js). Pour faire un essai pour de vrai
// en local, construire avec REACT_APP_ENV=staging.
if (ENV !== 'localhost') {
  Sentry.init({
    dsn: SENTRY_DSN,
    // Sépare les erreurs de staging de celles de la production dans le même projet.
    environment: ENV,
    // Journalisation des erreurs seulement : la mesure de performance (« tracing ») est
    // facultative chez Sentry depuis la v8 et se paie au volume. À rouvrir si on veut
    // suivre les temps de réponse.
    tracesSampleRate: 0,
    // Rien qui identifie l'entrepreneur (adresse IP, courriel) n'est joint par défaut.
    sendDefaultPii: false,
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
